export default __webpack_public_path__ + "static/storageChest-bf963dd703bca9228da2b6c793a75a90.svg";